import { useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Lightbox({ photos, index, onClose, onPrev, onNext }) {
  const photo = photos[index];

  const handleKey = useCallback(
    (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    },
    [onClose, onPrev, onNext]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [handleKey]);

  if (!photo) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/95 backdrop-blur-sm flex items-center justify-center animate-fade-in"
      data-testid="lightbox-overlay"
      onClick={onClose}
    >
      <button
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        className="absolute top-6 right-6 text-paper hover:text-paper-dim transition-colors p-2"
        aria-label="Cerrar"
        data-testid="lightbox-close"
      >
        <X size={28} strokeWidth={1.25} />
      </button>

      <button
        onClick={(e) => { e.stopPropagation(); onPrev(); }}
        className="absolute left-4 md:left-10 text-paper hover:text-paper-dim transition-colors p-2"
        aria-label="Anterior"
        data-testid="lightbox-prev"
      >
        <ChevronLeft size={42} strokeWidth={1} />
      </button>

      <button
        onClick={(e) => { e.stopPropagation(); onNext(); }}
        className="absolute right-4 md:right-10 text-paper hover:text-paper-dim transition-colors p-2"
        aria-label="Siguiente"
        data-testid="lightbox-next"
      >
        <ChevronRight size={42} strokeWidth={1} />
      </button>

      <div className="max-w-[90vw] max-h-[90vh] flex flex-col items-center gap-6" onClick={(e) => e.stopPropagation()}>
        <img
          src={photo.image_data}
          alt={photo.title}
          className="max-h-[78vh] max-w-[90vw] object-contain"
          data-testid="lightbox-image"
        />
        <div className="text-center">
          <div className="font-serif-display text-paper text-xl tracking-tight">{photo.title}</div>
          {photo.description && (
            <div className="mt-1 text-paper-dim font-light text-sm">{photo.description}</div>
          )}
          <div className="mt-2 eyebrow">
            {index + 1} / {photos.length} · {labelOf(photo.category)}
          </div>
        </div>
      </div>
    </div>
  );
}

function labelOf(c) {
  return c === "portraits" ? "Retratos" : c === "street" ? "Calle" : "Edificios";
}
